import { configureStore } from '@reduxjs/toolkit';
import paisReducer from './pais_slice';
import sesionReducer from './session_slice';
import lugarReducer from './lugar_slice';
import regionReducer from './region_slice';
import personaReducer from './persona_slice';
import institucionReducer from './institucion_slice';
import requisitoReducer from './requisito_slice';
import situacionReducer from './situacion_slice';
import afiliadoReducer from './afiliado_slice';
import segSituAfiliadoReducer from './seg_situ_afiliado_slice';
import tituloProfesionalReducer from './tituloProfesional_slice';
import afiliadoRequisitoReducer from './afiliadoRequisito_slice';
import areaProyectoReducer from './areaProyecto_slice';
import categoriaReducer from './categoria_slice';
import inmuebleReducer from './inmueble_slice';
import tipoProyectoReducer from './tipoProyecto_slice';
import tipologiaReducer from './tipologia_slice';
import proyectoReducer from './proyecto_slice';
import zonaReducer from './zona_slice';
import propietarioReducer from './propietario_slice';
import unidadReducer from './unidad_slice';
import planCuentasReducer from './planCuentas_slice';
import comprobanteReducer from './comprobante_slice';
import valoradoReducer from './valorado_slice';
import valoradoDetReducer from './valoradoDet_slice';
import reciboReducer from './recibo_slice';
import cuotaReducer from './cuota_slice';
import bancoReducer from './banco_slice';
import depositoReducer from './deposito_slice';
import valoradoVenReducer from './valoradoVen_slice';
import ingresosVariosReducer from './ingresosVarios_slice';
import cajaReducer from './caja_slice';
import usuarioReducer from './usuario_slice'; // Reducer de usuario
import rolReducer from './rol_slice';
import procesoReducer from './proceso_slice';
import indiceCalculoReducer from './indice_calculo_slice';
import datGeneralReducer from './datGeneral_slice'; // Reducer de datgeneral
import backupReducer from './backup_slice'; // Reducer del backup
import gradoReducer from './grado_slice';
import detalleComprobanteReducer from './detalleComprobante_slice';
import directivaReducer from './directiva_slice';
import cargoReducer from './cargo_slice';
import dirAfiliadoReducer from './dirAfiliado_slice';
import noticiaReducer from './noticia_slice';
import portadaReducer from './portada_slice';
import authReducer from './auth_slice'; // Importar el auth_slice
import captchaReducer from './captcha_slice'; // Importar captcha_slice
import chatbotBubbleReducer from './chatbotBubble_slice'; // Chatbot bubble slice

// >>> agregado: slice de habilitación local
import habilitacionLocalReducer from './habilitacionLocal_slice';
import sancionReducer from './sancion_slice';

const store = configureStore({
  reducer: {
    noticia: noticiaReducer,
    portada: portadaReducer,
    cargo: cargoReducer,
    dirafiliado: dirAfiliadoReducer,
    directiva: directivaReducer,
    valoradoVen: valoradoVenReducer,
    valoradoDet: valoradoDetReducer,
    valorado: valoradoReducer,
    pais: paisReducer,
    sesion: sesionReducer,
    lugar: lugarReducer,
    unidad: unidadReducer,
    zona: zonaReducer,
    region: regionReducer,
    persona: personaReducer,
    propietario: propietarioReducer,
    institucion: institucionReducer,
    requisito: requisitoReducer,
    afiliado: afiliadoReducer,
    segSituAfiliado: segSituAfiliadoReducer,
    situacion: situacionReducer,
    tituloProfesional: tituloProfesionalReducer,
    afiliadorequisito: afiliadoRequisitoReducer,
    areaProyecto: areaProyectoReducer,
    categoria: categoriaReducer,
    inmueble: inmuebleReducer,
    tipoProyecto: tipoProyectoReducer,
    tipologia: tipologiaReducer,
    proyecto: proyectoReducer,
    planCuentas: planCuentasReducer,
    comprobante: comprobanteReducer,
    detalleComprobantes: detalleComprobanteReducer,
    recibo: reciboReducer,
    cuota: cuotaReducer,
    banco: bancoReducer,
    deposito: depositoReducer,
    ingresosVarios: ingresosVariosReducer,
    caja: cajaReducer,
    usuario: usuarioReducer,
    rol: rolReducer,
    proceso: procesoReducer,
    indiceCalculo: indiceCalculoReducer,
    datgeneral: datGeneralReducer,
    backup: backupReducer,
    grado: gradoReducer,
    auth: authReducer,
    captcha: captchaReducer,
    chatbotBubble: chatbotBubbleReducer,

    // >>> agregado: reducer de habilitación local
    habilitacionLocal: habilitacionLocalReducer,
    sancion: sancionReducer, // <<< agregado
  },
});

export default store;
